import { cronosClient } from "@/config/client"

interface Course {
  courseId: string
  totalRealDuration: number
}

export interface WeekRealStudyTime {
  weekNumber: number
  courses: Course[]
}

export interface GetRealHoursOfStudyResponse {
  description: {
    weeks: WeekRealStudyTime[]
  }
}

export function getRealHoursOfStudy(weeksBack = 1) {
  return cronosClient.get<GetRealHoursOfStudyResponse>(
    `/v1/weekly-objectives/real-study-time?weeksBack=${weeksBack}`,
  )
}
